import { render, staticRenderFns } from "./BirthdateInput.vue?vue&type=template&id=1c5dec8d&"
import script from "./BirthdateInput.vue?vue&type=script&lang=js&"
export * from "./BirthdateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports